import React from "react";
import { Link } from "react-router-dom";
import ShopNav from "@/components/ShopNav";
import Footer from "@/components/sections/Footer";
import { useLang } from "@/i18n/LanguageContext";
import { XCircle } from "lucide-react";

export default function OrderCancelledPage() {
  const { t } = useLang();
  return (
    <main data-testid="cancelled-page" className="min-h-screen bg-cream-100 text-charcoal">
      <ShopNav />
      <section className="max-w-2xl mx-auto px-6 py-24 text-center">
        <XCircle className="mx-auto text-charcoal" size={48} strokeWidth={1.3} />
        <h1 className="mt-8 font-serif text-4xl text-olive-900">{t("cancelled_page.title")}</h1>
        <p className="mt-4 text-olive-800/80 font-light">{t("cancelled_page.subtitle")}</p>
        <Link
          to="/carrito"
          className="mt-8 inline-flex items-center gap-2 px-8 py-4 bg-olive-700 text-cream-100 text-[12px] uppercase tracking-[0.26em]"
        >
          {t("cancelled_page.back_cart")}
        </Link>
      </section>
      <Footer />
    </main>
  );
}
